"use client";

import { GraduationCapIcon, UsersIcon } from "lucide-react";

import { AUDIENCE_OPTIONS, type UserAudience } from "@/lib/onboarding/constants";

import type { StepProps } from "../types";
import { SingleChoiceStep, useChooseAndAdvance } from "../ui";

// Typed as a Record so a new audience value fails to compile until it has
// an icon.
const AUDIENCE_ICONS: Record<UserAudience, typeof GraduationCapIcon> = {
  student: GraduationCapIcon,
  instructor: UsersIcon,
};

export function RoleStep(props: StepProps) {
  const choose = useChooseAndAdvance(props);
  return (
    <SingleChoiceStep
      kicker="About you"
      title="First, which one are you?"
      options={AUDIENCE_OPTIONS.map((o) => ({ ...o, icon: AUDIENCE_ICONS[o.value] }))}
      selected={props.state.answers.audience}
      onPick={(audience) => choose({ audience })}
    />
  );
}
